export enum BookingConstantEnum {
  ADD_NEW_BOOKING = "ADD_NEW_BOOKING",
  GET_ALL_BOOKINGS = "GET_ALL_BOOKINGS",
  BOOKING = "BOOKING",
  INVITE_PEOPLE = "INVITE_PEOPLE",
  ADD_FEEDBACK = "ADD_FEEDBACK",
  ADD_FEEDBACK_REPLY = "ADD_FEEDBACK_REPLY",
}
